import { useState } from 'react';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Banner } from 'components';
import { NavigationService } from 'services';
import { UserModel } from 'models';
import { AppConfig } from 'config';
import { UserSelectors } from 'reducers/User/selectors';
import { RouterProps, withRouter } from "utils/route";
import { ApplicationState } from 'reducers/types';
import { AuthSelectors } from 'reducers/Auth/selectors';


export interface AppBannerProps extends RouterProps {
  user: UserModel;
  userLoading: boolean;
}


function AppBannerUnconnected({ user, userLoading, navigate }: AppBannerProps) {
  const [showBanner, setShowBanner] = useState(true);

  const onBannerClose = () => {
    setShowBanner(false);
  };

  const onConfirmAccountBannerClick = () => {
    navigate(NavigationService.getUserConfirmationPath());
  }

  const renderBanner = () => {
    if (!showBanner) return null;

    if (!user || !user.isAuthenticated() && !userLoading) {
      return (
        <Banner
          header={`${AppConfig.APP_NAME} is currently invite only`}
          message={'Join our waitlist to gain early full access'}
          onClose={onBannerClose}
          dismissable={true} />
      );
    } else if (user && !user.isConfirmed() && !userLoading) {
      return (
        <Banner
          header={"Account not confirmed"}
          message={"Please confirm your account to gain full access"}
          buttonText={"Confirm Account"}
          buttonClick={onConfirmAccountBannerClick}
          status={'warning'}
          dismissable={false} />
      );
    }
  };

  return (
    <>
      {renderBanner()}
    </>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  user: UserSelectors.getUser(state),
  userLoading: UserSelectors.getUserLoading(state) || AuthSelectors.getUserLoading(state)
});

const mapDispatchToProps = (dispatch: Dispatch<ApplicationState>) => bindActionCreators(
  {},
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppBannerUnconnected));
